import { render, staticRenderFns } from "./CiGenericNavigation.vue?vue&type=template&id=6ae6599a&scoped=true&"
import script from "./CiGenericNavigation.vue?vue&type=script&lang=js&"
export * from "./CiGenericNavigation.vue?vue&type=script&lang=js&"
import style0 from "./CiGenericNavigation.vue?vue&type=style&index=0&id=6ae6599a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae6599a",
  null
  
)

component.options.__file = "CiGenericNavigation.vue"
export default component.exports